export const initialState = {};

const addWidgetData = (key, widgetData, isError, isLoading) => {
    return {
        [key]: {
            data: {
                ...widgetData
            },
            isError,
            isLoading
        }
    };
};

export const getKey = url => {
    return url.split('?')[0];
};

export default (state = initialState, action) => {
    const key = getKey(action.url || '');

    switch (action.type) {
        case 'REQUEST_WIDGET_CONFIG':
            return {
                ...state,
                ...addWidgetData(key, {}, false, true)
            };

        case 'RECEIVE_WIDGET_CONFIG':
            return {
                ...state,
                ...addWidgetData(key, action.data, false, false)
            };

        case 'ERROR_WIDGET_CONFIG':
            return {
                ...state,
                ...addWidgetData(key, {}, true, false)
            };

        default:
            return state;
    }
};
